import React from "react";
import ServiceIconBase, { ServiceIconProps } from "./ServiceIconBase";

/** Graduation cap — "Educación". */
export const EducationIcon: React.FC<ServiceIconProps> = ({ size }) => (
  <ServiceIconBase size={size}>
    <path d="M12 4L1.5 9 12 14l10.5-5z" />
    <path d="M5.5 11.3V16c0 1.5 2.9 3 6.5 3s6.5-1.5 6.5-3v-4.7" />
  </ServiceIconBase>
);

export default EducationIcon;
